export const SITE_URL = 'https://the4people.com';
export const SITE_NAME = 'The4People';
export const SITE_TITLE = 'The4People — software development company';
export const SITE_DESCRIPTION = 'We build mobile apps, CRM/ERP systems, web services and software solutions.';
export const MAIN_EMAIL = 'mail@sirius-tech.dev';
